<template>
  <div>
    <v-text-field prepend-icon="search" flat :value="value" @input="updateValue"
                  @focus="focused=true" @blur="focused = false" :error-messages="errorMessages"/>
    <div id="searchOptionsContainer">
      <div id="searchOptions" v-show="show"
           @mouseover="hasMouse = true" @mouseout="hasMouse = false">
        <v-list v-if="filteredOptions.length > 0" class="optionList">
          <v-list-tile v-for="item in filteredOptions" :key="getKey(item)" @click="select(item)">
            {{ getLabel(item) }}
          </v-list-tile>
        </v-list>
        <v-card v-else>
          <v-card-title>No results</v-card-title>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      options: {},
      minchars: { default: 3 },
      labelpath: { default: null },
      keypath: { default: null },
      value: { default: '' },
      errorMessages: { default: () => [] }
    },
    data() {
      return {
        focused: false,
        hasMouse: false
      };
    },
    computed: {
      filteredOptions() {
        if (this.value.length >= this.minchars) {
          return this.options.filter((opt) =>
            this.getLabel(opt).toLowerCase().includes(this.value.toLowerCase())
          ).sort();
        } else {
          return [];
        }
      },
      show() {
        return this.value.length >= this.minchars && (this.focused || this.hasMouse);
      }
    },
    methods: {
      getLabel(item) {
        return this.labelpath ? item[this.labelpath] : item;
      },
      getKey(item) {
        return this.keypath ? item[this.keypath] : item;
      },
      select(item) {
        this.$emit('select', item);
        this.hasMouse = false;
      },
      updateValue(value) {
        this.$emit('input', value);
      }
    }
  };
</script>

<style lang="less" scoped>
  #searchOptionsContainer {
    height: 0;
    overflow: visible;
  }

  #searchOptions {
    position: fixed;
    z-index: 50;
    box-shadow: 0 4px 8px #dddddd;

    .optionList {
      padding: 0;
    }
  }
</style>
